// extracted by mini-css-extract-plugin
module.exports = {"container":"TalisStandbyBanner_container__3zzwy","wrap":"TalisStandbyBanner_wrap__ryl-G","sub":"TalisStandbyBanner_sub__WrgYm","content":"TalisStandbyBanner_content__13xkB"};